import React, { Component } from "react";
import format from 'format-number'
import Alert from 'react-s-alert'
import { FOTO_PRESENSI_HOST } from "../../constants/siteConfig";
import qs from 'qs'
import axios from '../../axios'


const initialState = {    
    content_id         : "",
    content_type       : "",
    content_name       : "",
    content_image      : "",
    content_alias      : "",
    content_tags		: "",
    content_hits		: "",
    isButtonLoading     : false,
    isLoading           : false,
    detailPresensi    : []
}

class DetailPresensiGuru extends Component {
    constructor(props) {
        super(props)
        this.state = initialState
    }            

    loadDetailData() {
		
    	const params = qs.stringify({
			attendance_id:this.props.match.params.presensi_id
		});

        axios({
            method: 'post',
            url: '/attendanceguru/detail?' + params
        })
        .then(response => {
            const result = response.data;
            console.log(result)
			if (result.status === true) {
				this.setState({
					detailPresensi: result.data.presensis[0],
					isLoading: false
				});
			} else {
				Alert.error(result.text);
				this.setState({ isLoading: false });
			}
		})
		.catch(error => {
			console.log(error);
			this.setState({ isLoading: false });
			Alert.error("Gagal terhubung ke server!");
		});
    }
    
    componentDidMount() {
        this.loadDetailData()
    }
    
    render() {

        return (
            <div className="col-sm-12">                
                <div className="card">
                    <div className="card-header">
                        Detail Presensi
                    </div>
                    <div className="card-block">
                        <div className="col-lg-12 form-group row">

                            <div className="col-md-4">
                                <div className="form-group row">
                                    <div className="col-md-12">
                                    <img
                                        src={
                                            this.state.detailPresensi.presensi_foto !== "" ? FOTO_PRESENSI_HOST+this.state.detailPresensi.presensi_foto : "./noimage.gif"
                                        }
                                        alt=""
                                        className="img-thumbnail"
                                        style={{ maxWidth: "400px" ,maxHeight: "400px" }}
                                    />
                                    </div>
                                </div>  
                            </div>

                            <div className="col-md-8">
                                <div className="form-group row">
                                    <label className="col-md-3 form-control-label">Nama Lengkap</label>
                                    <div className="col-md-9">
                                        {": "}<b>{this.state.detailPresensi.user_nama}</b>
                                    </div>
                                </div>
                                {/*<div className="form-group row">
                                                                    <label className="col-md-3 form-control-label">Kelas</label>
                                                                    <div className="col-md-9">
                                                                        {": "}<b>{this.state.detailPresensi.kelas_nama}</b>
                                                                    </div>
                                                                </div>*/}
                                <div className="form-group row">
                                    <label className="col-md-3 form-control-label">Presensi</label>
                                    <div className="col-md-9">
                                        {": "}<b>{this.state.detailPresensi.presensi_tipe}</b>
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-md-3 form-control-label">Status</label>
                                    <div className="col-md-9">
                                        {": "}<b>{this.state.detailPresensi.presensi_status}</b>
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-md-3 form-control-label">Tanggal</label>
                                    <div className="col-md-9">
                                        {": "}<b>{this.state.detailPresensi.presensi_create_date}</b>
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-md-3 form-control-label">Waktu Masuk</label>
                                    <div className="col-md-9">
                                        {": "}<b>{this.state.detailPresensi.presensi_create_time}</b>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>                    
            </div>
        );
    }
}

export default DetailPresensiGuru;


// WEBPACK FOOTER //
// ./src/views/Users/DetailPresensiGuru.js